module.exports = __webpack_public_path__ + "static/media/014-wales.ed92423f.svg";